import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _typeof from "/app/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
Object.equal = function (a, b) {
  if (_typeof(a) !== "object" || _typeof(b) !== "object") {
    return false;
  }
  if (Object.keys(a).length !== Object.keys(b).length) {
    return false;
  }
  return Object.entries(a).every(function (x) {
    var obj = Object.entries(b).find(function (y) {
      return y[0] === x[0];
    });
    switch (_typeof(obj[1])) {
      case "object":
        if (obj[1] === null) {
          return x[1] === null;
        } else {
          return Object.equal(obj[1], x[1]);
        }
      default:
        return obj[1] === x[1];
    }
  });
};
Object.flat = function (obj) {
  var nullishValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Object.entries(obj).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (nullishValues.length > 0) {
      if (nullishValues.includes(value)) return acc;
    } else if (!value) return acc;
    if (_typeof(value) === "object") return _objectSpread(_objectSpread({}, acc), Object.flat(value));
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value));
  }, {});
};
Object.isObject = function (value) {
  return _typeof(value) === "object" && !Array.isArray(value) && value !== null;
};

//blobException to standardException managable by getErrorData
Object.blobExToJsonEx = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
    var _e$response;
    var text;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 ? void 0 : _e$response.text();
        case 2:
          text = _context.sent;
          if (text) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", e);
        case 5:
          return _context.abrupt("return", {
            response: {
              data: JSON.parse(text)
            }
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();
Object.encodeToUri = function (object) {
  var jsonString = JSON.stringify(object, null, 0);
  return encodeURIComponent(jsonString);
};
Object.deepCopy = function (object) {
  if (object === null || _typeof(object) !== "object") {
    return object;
  }
  var copy = Array.isArray(object) ? [] : {};
  for (var key in object) {
    if (object.hasOwnProperty(key)) {
      copy[key] = Object.deepCopy(object[key]);
    }
  }
  return copy;
};
Object.jsonClone = function (object) {
  return JSON.parse(JSON.stringify(object));
};
export default Object;